import React from 'react';
import {useBan} from '../../../hooks/useBan'

const TabsItemOne = ({ nesting, subTitle, title, eqv, setEqv, setIsOpenAside }) => {
    const {isBan, clearAllChanges, setIsBan} = useBan()

    const handleClick = () => {
        if (isBan) {
            setIsBan(true)
            return
        }
        clearAllChanges()
        setEqv(subTitle)
        setIsOpenAside(state => !state) 
    }

    return (
        <div className={`asside_menu_server_tabs_item ${subTitle === eqv ? 'asside_menu_server_tabs_item_active' : ' '} ${nesting ? 'asside_menu_server_tabs_item_active_nesting_before' : ''}`}
        onClick={handleClick}>
                <div 
                className='asside_menu_server_tabs_item_name'>
                    {/* <img src={`/img/asside_icon/${title}.svg`} alt="" /> */}
                    <img src={`/img/asside_icon/${subTitle === eqv ? `${title}Active.svg` : `${title}.svg`}`} alt="" />
                    <p>{title}</p>
                </div>
        </div>
    );
};

export default TabsItemOne;